module.exports = __webpack_public_path__ + "static/media/ic_premium_onboarding_small.915dd0e8.svg";